import '../assets/styles/App.css';
import React, { useState, useEffect, useRef } from 'react';

import axios from 'axios';
import '../assets/styles/insideticket.css';
import PhotoUpload from '../components/PhotoUpload';

import miniMonitor from '../assets/images/mini-monitor.png';
import saveButton from '../assets/images/save-button.png';
import replayButton from '../assets/images/replay-button.png';
import linkButton from '../assets/images/emothion-theme-park.png';
import stripe from '../assets/images/stripe.png';
// import useSearchParams
import { useSearchParams } from 'react-router-dom';
import Loading from '../components/Loading';

function InsideTicket() {
    // useSearchParams and get ticketId and ticketType
    const [isLoading, setIsLoading] = useState(false);
    const [state, setState] = useState(0);
    const [searchParams] = useSearchParams();
    const [ticketId, setTicketId] = useState('');
    const [imageData, setImageData] = useState(null);
    const [editable, setEditable] = useState(false);
    const [monitorImageWidth, setMonitorImageWidth] = useState('100%');
    const [monitorImageHeight, setMonitorImageHeight] = useState('100%');
    const [monitorImageTop, setMonitorImageTop] = useState('0px');
    const [monitorImageLeft, setMonitorImageLeft] = useState('0px');
    const [audioData, setAudioData] = useState('');
    const [audio, setAudio] = useState(new Audio());

    useEffect(() => {
        calculateMonitorImageSize();
        if (imageData !== null && editable) {
            setState(1);
        }
    }, [imageData]);

    useEffect(() => {
        setIsLoading(true);
        setTicketId(searchParams.get('ticketId').toString());

        const getTicketData = async () => {
            const data = {
                ticketId: searchParams.get('ticketId'),
            };

            const config = {
                headers: { Authorization: process.env.REACT_APP_DOBBY_TOKEN },
            };

            axios
                .post(
                    `${process.env.REACT_APP_API_URL}/getTicketAdmin`,
                    data,
                    config
                )
                .then((res) => {
                    if (res.data.imageUrl.S !== '') {
                        setImageData(res.data.imageUrl.S);
                        setEditable(false);

                        if (res.data.signatureImageUrl.S !== '') {
                            // if today's date is 7 days after from the activate date, then set state to 2
                            let today = new Date();
                            let activateDate = new Date(
                                res.data.activateDate.S
                            );
                            let diffTime = Math.abs(today - activateDate);
                            let diffDays = Math.ceil(
                                diffTime / (1000 * 60 * 60 * 24)
                            );
                            if (diffDays > 7) {
                                setState(2);
                            } else {
                                setAudioData(res.data.signatureImageUrl.S);
                                setState(3);
                            }
                        } else {
                            setState(2);
                        }
                    } else {
                        setEditable(true);
                        setState(0);
                    }
                    setIsLoading(false);
                })
                .catch((err) => {
                    setIsLoading(false);
                    console.log(err);
                });
        };
        getTicketData();
    }, []);

    const saveData = () => {
        if (imageData !== null) {
            setIsLoading(true);
            const config = {
                headers: {
                    Authorization: process.env.REACT_APP_DOBBY_TOKEN,
                },
            };

            const data = {
                ticketId: ticketId,
                imageUrl: imageData.replace(/^data:image\/[a-z]+;base64,/, ''),
            };

            axios
                .post(
                    `${process.env.REACT_APP_API_URL}/updateTicket`,
                    data,
                    config
                )
                .then((res) => {
                    setIsLoading(false);
                    if (res.data) {
                        setEditable(false);
                        setState(2);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    setIsLoading(false);
                });
        } else {
            alert('사진을 업로드 해주세요');
        }
    };

    const calculateMonitorImageSize = () => {
        if (imageData === null) return;
        let monitorWidth =
            document.getElementById('mini-monitor-image').offsetWidth * 0.53;
        let monitorHeight =
            document.getElementById('mini-monitor-image').offsetHeight * 0.4;

        let image = new Image();
        let finalImageHeight = 0;
        let finalImageWidth = 0;
        image.onload = function () {
            if (image.width >= monitorWidth || image.height >= monitorHeight) {
                if (image.width > image.height) {
                    if (
                        (monitorWidth * image.height) / image.width >
                        monitorHeight
                    ) {
                        finalImageWidth = monitorHeight;
                        finalImageHeight =
                            (monitorHeight * image.height) / image.width;
                    } else {
                        finalImageWidth = monitorWidth;
                        finalImageHeight =
                            (monitorWidth * image.height) / image.width;
                    }

                    setMonitorImageWidth(finalImageWidth + 'px');
                    setMonitorImageHeight(finalImageHeight + 'px');
                } else {
                    finalImageWidth =
                        (monitorHeight * image.width) / image.height;
                    finalImageHeight = monitorHeight;

                    setMonitorImageWidth(finalImageWidth + 'px');
                    setMonitorImageHeight(finalImageHeight + 'px');
                }
            }

            let monitorTop = Math.abs(monitorHeight - finalImageHeight) / 2;
            let monitorLeft = Math.abs(monitorWidth - finalImageWidth) / 2;

            let deviceWidth = window.innerWidth;

            setMonitorImageTop(
                `calc(${
                    deviceWidth > 767 && deviceWidth < 1024 ? '4' : '3'
                }rem + ${monitorTop}px)`
            );
            setMonitorImageLeft(`calc(24% + ${monitorLeft}px)`);
        };
        image.src = imageData;
    };

    const playAudio = () => {
        audio.src = audioData;
        audio.play();
    };

    return isLoading ? (
        <Loading />
    ) : (
        <div className='temporary-qr-container inside-background'>
            <div className='stripe-background'>
                <img src={stripe} />
            </div>
            <>
                <div id='mini-monitor'>
                    <img
                        id='mini-monitor-image'
                        style={{ width: '100%' }}
                        src={miniMonitor}
                    />

                    {imageData === null || imageData === '' ? (
                        <div className='monitor-text'>
                            [감정 테마 파크]에 온 것을 환영합니다
                            <div></div>사랑하는 대상이 있나요?
                            <div></div>사랑하는 대상을 떠올릴 수 있는 사진을
                            전송해 주세요
                        </div>
                    ) : (
                        <img
                            style={{
                                width: monitorImageWidth,
                                height: monitorImageHeight,
                                top: monitorImageTop,
                                left: monitorImageLeft,
                            }}
                            src={imageData}
                            className='inside-imageuploaded'
                            alt='photo'
                        />
                    )}
                </div>
                <div className='onBoarding-guide'>
                    {(state === 0 || state === 1) && editable ? (
                        <PhotoUpload
                            type={0}
                            setImage={setImageData}
                        ></PhotoUpload>
                    ) : null}

                    <div
                        style={{
                            fontFamily: 'DungGeunMo',
                            fontSize: '14px',
                            color: 'black',
                            textAlign: 'center',
                            marginTop: '0.5rem',
                        }}
                    >
                        {state === 0 && editable ? (
                            '전시 작품 참여를 위해 사진을 업로드 해주세요'
                        ) : state === 1 && editable ? (
                            <div style={{ marginTop: '1.5rem' }}>
                                <img
                                    onClick={() => {
                                        saveData();
                                    }}
                                    className='pixel-button'
                                    src={saveButton}
                                />
                                <div>저장 후 수정할 수 없습니다</div>
                            </div>
                        ) : state === 2 && !editable ? (
                            <p
                                style={{
                                    lineHeight: '1.3rem',
                                    fontSize: '18px',
                                }}
                            >
                                사진이 저장되었습니다.
                                <br />
                                3층 작품을 통해{' '}
                                <span style={{ color: '#9F4CFF' }}>사랑</span>을
                                고백해 보세요
                            </p>
                        ) : state === 3 && !editable ? (
                            <div style={{ paddingTop: '20px' }}>
                                <div>
                                    <p
                                        style={{
                                            lineHeight: '1.3rem',
                                            fontSize: '18px',
                                        }}
                                    >
                                        [러브 다이얼로그]로 녹음된
                                        <br />
                                        사랑 고백입니다
                                    </p>
                                </div>
                                <img
                                    onClick={() => {
                                        playAudio();
                                    }}
                                    className='pixel-button'
                                    src={replayButton}
                                />
                                <div>일주일 후까지 재생 가능합니다</div>
                                <div style={{ marginTop: '1.5em' }}>
                                    <img
                                        onClick={() => {
                                            window.open(
                                                'https://booking.naver.com/booking/12/bizes/1099573'
                                            );
                                        }}
                                        style={{ width: '90%' }}
                                        src={linkButton}
                                    />
                                </div>
                            </div>
                        ) : null}
                    </div>
                </div>
                {editable ? (
                    <div className='state-indicator'>
                        <div
                            style={{
                                backgroundColor: `${
                                    state === 0 ? '#9F4CFF' : '#D9D9D9'
                                }`,
                            }}
                        ></div>
                        <div
                            style={{
                                backgroundColor: `${
                                    state === 1 ? '#9F4CFF' : '#D9D9D9'
                                }`,
                                margin: '0px 1.3rem',
                            }}
                        ></div>
                        <div
                            style={{
                                backgroundColor: `${
                                    state === 2 ? '#9F4CFF' : '#D9D9D9'
                                }`,
                            }}
                        ></div>
                    </div>
                ) : null}
            </>
        </div>
    );
}

export default InsideTicket;
